import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import type { TMeta } from '@cian/logger/shared';
import type { FetchResponse } from '@cian/http-api';

import { TThunkAction } from '../../types/redux';
import { setPaymentId, setPaymentStatus } from './actions';
import { fetchGetBillingStatus, TGetBillingStatusResponse } from '../../repositories/legal-check/v1/get-billing-status';

export const getPaymentStatus =
  (paymentId: string): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    const { httpApi, logger } = context;

    dispatch(setPaymentId(paymentId));

    try {
      const res: FetchResponse<TGetBillingStatusResponse> = await fetchGetBillingStatus({
        httpApi,
        parameters: {
          requestId: Number(paymentId),
        },
      });

      if (res.statusCode === 200) {
        dispatch(setPaymentStatus(res.response.status));

        return;
      }

      throw new HttpBadStatusCodeError(
        res.response?.message || /* istanbul ignore next */ 'Ошибка при получении статуса оплаты',
        res.statusCode,
      );
    } catch (error) {
      logger.error(`Не удалось получить статус платежа ${paymentId}`, error as TMeta);
    }
  };
